/*
 * Eluxa: require a phone model before a case can be bought.
 *
 * Dawn pre-selects the first model in the variant dropdown, so a shopper could add a case without choosing a
 * phone. On the Anti-Yellow case template this puts a disabled "Select your phone model" placeholder in the
 * model dropdown and blocks Add to cart, Buy Now (incl. Razorpay Magic Checkout / dynamic checkout buttons that
 * are injected by third-party scripts) and the sticky bar until a real model is chosen.
 *
 * Skipped when: the URL already carries ?variant= (e.g. the phone-model auto-redirect chose the model, or a
 * shared link), or the product has only one model to choose from.
 */
(function () {
  'use strict';

  var root = document.getElementById('eluxa-model-required');
  if (!root) return;

  var cfg = {};
  try { cfg = JSON.parse(root.getAttribute('data-config')) || {}; } catch (e) {}
  var placeholderText = cfg.placeholder || 'Select your phone model';
  var errorText = cfg.error || 'Please select your phone model';

  if (new URLSearchParams(location.search).has('variant')) return;

  var selects = Array.prototype.slice.call(document.querySelectorAll('variant-selects select'));
  if (!selects.length) return;
  var select = selects.filter(function (s) { return /model/i.test(s.name || ''); })[0] || selects[0];
  if (select.options.length < 2) return;

  var scope = document.querySelector('product-info') || document.querySelector('main') || document.body;
  var wrapper = select.closest('.product-form__input') || select.parentNode;
  var buttons = scope.querySelector('.product-form__buttons') || document.querySelector('.product-form__buttons');
  var stickyBuy = document.querySelector('.eluxa-sticky-bar__buy');
  var form = select.form || document.getElementById(select.getAttribute('form'));

  // Third-party buy buttons (Razorpay Magic Checkout "Buy Now", Shopify dynamic checkout, ...)
  var BUY_NAME = /razorpay|rzp|magic-?checkout|magic-?btn|buy-?now|buy_now|payment-button|dynamic-checkout|accelerated/i;
  var BUY_TEXT = /\bbuy\b/i;
  var KEEP = 'variant-selects, .product-form__input, quantity-input, .quantity, media-gallery, .product__media-wrapper, .thumbnail-list, .product__accordion, details, summary, .share-button';

  var style = document.createElement('style');
  style.textContent = '.eluxa-model-blocked{opacity:.5!important;cursor:not-allowed!important;pointer-events:none!important}@keyframes eluxa-shake{0%,100%{transform:translateX(0)}25%{transform:translateX(-6px)}75%{transform:translateX(6px)}}.eluxa-model-error .select{animation:eluxa-shake .3s}';
  document.head.appendChild(style);

  // Placeholder option (disabled so it can't be re-chosen). Not announced to Dawn: no change event is fired.
  var ph = document.createElement('option');
  ph.value = '';
  ph.textContent = placeholderText;
  ph.disabled = true;
  select.insertBefore(ph, select.firstChild);
  select.selectedIndex = 0;

  var msg = document.createElement('p');
  msg.className = 'eluxa-model-msg';
  msg.setAttribute('role', 'alert');
  msg.textContent = '';
  wrapper.appendChild(msg);

  var overlay = null;
  if (buttons) {
    buttons.classList.add('eluxa-model-locked');
    overlay = document.createElement('div');
    overlay.className = 'eluxa-model-overlay';
    overlay.setAttribute('aria-hidden', 'true');
    buttons.appendChild(overlay);
  }
  var locked = true;
  var marked = [];
  if (stickyBuy) {
    stickyBuy.setAttribute('disabled', 'disabled');
    stickyBuy.classList.add('eluxa-model-blocked');
    marked.push(stickyBuy);
  }

  // Disabled / pointer-events:none buttons swallow clicks, so also hit-test the click position against them.
  function pointOf(event) {
    var t = (event.changedTouches && event.changedTouches[0]) || (event.touches && event.touches[0]) || event;
    return typeof t.clientX === 'number' ? { x: t.clientX, y: t.clientY } : null;
  }
  function overBuyArea(event) {
    var pt = pointOf(event);
    if (!pt) return false;
    var els = marked.slice();
    if (buttons) els.push(buttons);
    for (var i = 0; i < els.length; i++) {
      var r = els[i].getBoundingClientRect();
      if (r.width && r.height && pt.x >= r.left && pt.x <= r.right && pt.y >= r.top && pt.y <= r.bottom) return true;
    }
    return false;
  }

  var toast = null, toastTimer = null;
  function showToast() {
    if (!toast) {
      toast = document.createElement('div');
      toast.setAttribute('role', 'alert');
      toast.style.cssText = 'position:fixed;left:50%;bottom:90px;transform:translateX(-50%);z-index:2147483000;max-width:90vw;background:#111;color:#fff;border:2px solid #ff6a00;border-radius:10px;padding:12px 18px;font:600 15px/1.3 sans-serif;box-shadow:0 6px 24px rgba(0,0,0,.35);text-align:center';
      document.body.appendChild(toast);
    }
    toast.textContent = errorText;
    toast.style.display = 'block';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.style.display = 'none'; }, 3500);
  }

  // True if this event path hits a purchase control (inside the product area, or any Razorpay-style element).
  function isBuyTarget(path) {
    var inScope = false, i, el;
    for (i = 0; i < path.length; i++) if (path[i] === scope) inScope = true;
    if (overlay && path.indexOf(overlay) !== -1) return true;
    if (buttons && path.indexOf(buttons) !== -1) return true;
    if (stickyBuy && path.indexOf(stickyBuy) !== -1) return true;
    for (i = 0; i < path.length; i++) {
      el = path[i];
      if (!el || el.nodeType !== 1) continue;
      if (el === document.body || el === document.documentElement) break;
      var sig = (el.id || '') + ' ' + (typeof el.className === 'string' ? el.className : '') + ' ' + el.tagName;
      if (BUY_NAME.test(sig)) return true;
    }
    if (!inScope) return false;
    for (i = 0; i < path.length; i++) {
      el = path[i];
      if (!el || el.nodeType !== 1) continue;
      if (el === scope) break;
      if (el.matches && el.matches(KEEP)) return false;
      var isCtl = el.tagName === 'BUTTON' || el.tagName === 'A' || el.tagName === 'INPUT' || el.getAttribute('role') === 'button';
      if (isCtl) {
        var label = (el.textContent || '') + ' ' + (el.value || '') + ' ' + (el.getAttribute('aria-label') || '');
        if (BUY_TEXT.test(label) || el.type === 'submit') return true;
      }
    }
    return false;
  }

  function mark() {
    var nodes = scope.querySelectorAll('button, a, input[type=submit], [role=button], [class*="razorpay" i], [id*="razorpay" i], [class*="rzp" i], [id*="rzp" i], [class*="magic" i]');
    Array.prototype.forEach.call(nodes, function (n) {
      if (n.closest(KEEP) || n === overlay || n.classList.contains('eluxa-model-blocked')) return;
      var sig = (n.id || '') + ' ' + (typeof n.className === 'string' ? n.className : '');
      var label = (n.textContent || '') + ' ' + (n.value || '') + ' ' + (n.getAttribute('aria-label') || '');
      if (BUY_NAME.test(sig) || BUY_TEXT.test(label) || n.type === 'submit') {
        n.classList.add('eluxa-model-blocked');
        marked.push(n);
      }
    });
  }

  // The default (first) variant id must not be readable by buy buttons that build their own checkout.
  function setIdInputs(off) {
    Array.prototype.forEach.call(document.querySelectorAll('input[name="id"]'), function (i) {
      if (off) i.setAttribute('data-eluxa-id-off', '1'); else i.removeAttribute('data-eluxa-id-off');
      i.disabled = !!off;
    });
  }

  function nudge() {
    msg.textContent = errorText;
    wrapper.classList.remove('eluxa-model-error');
    void wrapper.offsetWidth;
    wrapper.classList.add('eluxa-model-error');
    showToast();
    try { wrapper.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {}
    try { select.focus({ preventScroll: true }); } catch (e) {}
  }

  var observer = new MutationObserver(function () { if (locked) { mark(); setIdInputs(true); } });
  observer.observe(scope, { childList: true, subtree: true });
  mark();
  setIdInputs(true);

  var DOWN = ['pointerdown', 'mousedown', 'mouseup', 'pointerup', 'touchstart', 'touchend'];
  var ALL = DOWN.concat(['click', 'dblclick', 'auxclick', 'keydown', 'keyup', 'keypress', 'submit']);

  var lastNudge = 0;

  function guard(event) {
    if (!locked) return;
    if (event.type === 'keydown' || event.type === 'keyup' || event.type === 'keypress') {
      if (event.key !== 'Enter' && event.key !== ' ') return;
    }
    var path = event.composedPath ? event.composedPath() : [event.target];
    var hit = isBuyTarget(path) || overBuyArea(event);
    if (!hit && event.type === 'submit' && form && event.target === form) hit = true;
    if (!hit) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
    // Touch taps: cancelling touchend suppresses the synthetic click, so show the message on touchend / pointerup too.
    var touchTap = event.type === 'touchend' || (event.type === 'pointerup' && event.pointerType && event.pointerType !== 'mouse');
    if (event.type === 'click' || event.type === 'submit' || event.type === 'keydown' || touchTap) {
      var now = Date.now();
      if (now - lastNudge > 600) { lastNudge = now; nudge(); }
    }
  }

  ALL.forEach(function (t) { window.addEventListener(t, guard, true); });

  function unlock() {
    if (!locked) return;
    locked = false;
    observer.disconnect();
    msg.textContent = '';
    wrapper.classList.remove('eluxa-model-error');
    if (toast) toast.style.display = 'none';
    if (overlay) overlay.remove();
    if (buttons) buttons.classList.remove('eluxa-model-locked');
    if (stickyBuy) stickyBuy.removeAttribute('disabled');
    marked.forEach(function (n) { n.classList.remove('eluxa-model-blocked'); });
    marked = [];
    setIdInputs(false);
    ALL.forEach(function (t) { window.removeEventListener(t, guard, true); });
  }

  select.addEventListener('change', function () {
    if (select.value) unlock();
  });
})();
